// ----------------------------------------------------------------------------
// Component: Guarantees Bar
// ----------------------------------------------------------------------------
//
// A repeater of icon and title with the whole bar is clickable and opens a modal.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import '../../snippets/_containers/modal/modal';
import './_guarantee-bar.scss';